import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appPermission]',
})
export class PermissionDirective {
  @Input() appPermissionElse: any;
  @Input() appPermissionModule: string;
  @Input() set appPermission(requestedAction: string) {
    setTimeout(() => this.decideView(requestedAction));
  }

  modulesList = 'modules';

  constructor(
    private templateRef: TemplateRef<any>,
    private container: ViewContainerRef
  ) {}

  decideView(requestedAction: string) {
    if (this.hasPermission(requestedAction, this.appPermissionModule)) {
      this.container.createEmbeddedView(this.templateRef).detectChanges();
    } else {
      if (this.appPermissionElse) {
        this.container
          .createEmbeddedView(this.appPermissionElse)
          .detectChanges();
      } else {
        this.container.clear();
      }
    }
  }

  hasPermission(requestedAction: string, specificModule = '') {
    const actions = this.getModuleActions(specificModule);
    if (actions)
      return actions.find((action: string) => action.toLowerCase() === requestedAction.toLowerCase());
    return null;
  }

  getModuleActions(specificModule: string) {
    const moduleSet = JSON.parse(sessionStorage[this.modulesList]);
    return this.getModuleObject(moduleSet, specificModule)?.actions;
  }

  getModuleObject(module: any, specificModule: string) {
    if (module?.label === specificModule) {
      return module;
    }

    let response: any = null;
    const item = module?.length ? module : module?.children;
    for (let i = 0; i < item.length; i++) {
      response = response
        ? response
        : this.getModuleObject(item[i], specificModule);
    }

    return response;
  }
}
